export function currencyChanger ($elements) {
	$elements.each((i, el) => {
		const $element = $(el);
		const url = $element.data('currency-changer');
		$element.on('click', '[data-currency-control]', function (event) {
			const $this = $(this).has(event.target) ? $(this) : $(event.target);
			if (!$this.hasClass('is-active')) {
				$('[data-currency-control]').removeClass('is-active');
				$this.addClass('is-active');
				let currency = $this.data('currency-control');
				$('[data-currency]').not('.dropdown__item').addClass('_hide');
				$(`[data-currency="${currency}"]`).not('.dropdown__item').removeClass('_hide');
				$.ajax({
					url: url,
					type: 'post',
					data: {
						currency: currency
					}
				});
			}
		});
	});
}



// WEBPACK FOOTER //
// ./_HTML/src/js/_modules/currency-changer.js